// @flow
import { observer } from "mobx-react";
import { computed, observable, action } from "mobx";
import React from "react";
import Pagination from "sulu-admin-bundle/components/Pagination";
import {
    Table,
    GhostIndicator,
    PublishIndicator,
    Input,
} from "sulu-admin-bundle/components";
import FlatStructureStrategy from "sulu-admin-bundle/containers/List/structureStrategies/FlatStructureStrategy";
import DefaultLoadingStrategy from "sulu-admin-bundle/containers/List/loadingStrategies/DefaultLoadingStrategy";
import AbstractAdapter from "sulu-admin-bundle/containers/List/adapters/AbstractAdapter";
import listFieldTransformerRegistry from "sulu-admin-bundle/containers/List/registries/listFieldTransformerRegistry";
import abstractTableAdapterStyles from "sulu-admin-bundle/containers/List/adapters/abstractTableAdapter.scss";

import { mutationObserver } from "../misc";
import shirt from "../../svgs/Shirt";

//https://github.com/sulu/sulu/issues/6324

@observer
class InlineTableAdapter extends AbstractAdapter {
    @observable activeEditField = "";
    @observable updatedValue = "";

    static LoadingStrategy = DefaultLoadingStrategy;
    static StructureStrategy = FlatStructureStrategy;

    constructor(props) {
        super(props);

        this.state = {
            selected: 4,
            total: this.props.data.length, //data.length
        };

        this.countSelected = this.countSelected.bind(this);
    }

    componentDidMount() {
        mutationObserver('table[class^="table"]');
    }

    countSelected(targ) {
        if (targ.checked) {
            this.setState({
                selected: this.state.selected + 1,
            });
        } else {
            this.setState({
                selected: this.state.selected - 1,
            });
        }
    }

    @computed get schema() {
        const { schema } = this.props;

        const newSchema = {};

        for (const key of Object.keys(schema)) {
            if (
                schema[key].visibility === "never" ||
                schema[key].visibility === "no"
            ) {
                continue;
            }

            newSchema[key] = schema[key];
        }

        return newSchema;
    }

    cellType(item, schemaKey, transformer) {
        let value = "";
        if (item[schemaKey]) {
            value = transformer.transform(
                item[schemaKey],
                this.schema[schemaKey].transformerTypeParameters,
                item
            );
        }
        // else if(transformer.constructor.name === 'CheckBoxTransformer'){
        //   value = transformer.transform();
        // }

        // else if(transformer.constructor.name === 'ShirtTransformer'){
        //   value = transformer.transform();
        // }
        else {
            value = transformer.transform(false, this.countSelected);
        }

        return value;
    }

    renderCells(item) {
        const schemaKeys = Object.keys(this.schema);

        return schemaKeys.map((schemaKey, index) => {
            const transformer = listFieldTransformerRegistry.get(
                this.schema[schemaKey].type
            );

            const value = this.cellType(item, schemaKey, transformer);

            const indicators = [];

            if (index === 0) {
                if (item.ghostLocale) {
                    indicators.push(
                        <GhostIndicator
                            className={
                                abstractTableAdapterStyles.ghostIndicator
                            }
                            key="ghost"
                            locale={item.ghostLocale}
                        />
                    );
                } else {
                    if (
                        item.publishedState !== undefined ||
                        item.published !== undefined
                    ) {
                        const draft = !item.publishedState;
                        const published = !!item.published;

                        if (draft || !published) {
                            indicators.push(
                                <PublishIndicator
                                    className={
                                        abstractTableAdapterStyles.publishIndicator
                                    }
                                    draft={draft}
                                    key="publish"
                                    published={published}
                                />
                            );
                        }
                    }
                }
            }

            const notEditable = ["someCheckBox", "shirt", "webcollection"];

            //+ item.shortName.replace(/[^\w\n\t]/g,"_")
            return (
                <Table.Cell
                    key={item.id + schemaKey}
                    width={this.schema[schemaKey].width}
                >
                    {this.activeEditField === item.id + schemaKey &&
                    notEditable.indexOf(schemaKey) === -1 ? (
                        <div
                            style={{
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                                cursor:
                                    schemaKey === "changed"
                                        ? "normal"
                                        : "pointer",
                            }}
                        >
                            <Input
                                value={this.updatedValue}
                                onBlur={this.handleSave}
                                onKeyPress={this.handleKeyPress}
                                onChange={this.handleChange}
                            />
                        </div>
                    ) : (
                        <div
                            // onClick={() => {
                            //     this.changeActiveInlineEdit(
                            //         item.id,
                            //         schemaKey, // + id
                            //         "", //item.shortName.replace(/[^\w\n\t]/g,"_"),
                            //         value
                            //     );
                            // }}
                            style={{
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                                cursor:
                                    schemaKey === "changed"
                                        ? "normal"
                                        : "pointer",
                            }}
                        >
                            {indicators}
                            {value}
                        </div>
                    )}
                </Table.Cell>
            );
        });
    }

    handleKeyPress = (key) => {
        if (key === "Enter") this.handleSave();
    };

    @action handleSave = (ev) => {
        this.processing = true;

        const entity = "venues";
        const id = "2";
        //this.props.data
        //debugger;
        // @TODO:: dynamic endpoint?
        let baseUrl = location.protocol + "//" + location.host;
        let endpointUpdateUrl = baseUrl + `/admin/api/${entity}/${id}`;

        // Build request options.
        const requestOptions = {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
            body: JSON.stringify({
                title: this.updatedValue,
                type: "inline",
            }),
        };

        // Fire request.
        fetch(endpointUpdateUrl, requestOptions)
            .then((response) => response.json())
            .then(
                action((response) => {
                    this.processing = false;
                    if (response.status === 200) {
                    } else {
                        console.log(this.errorMessage);
                    }
                })
            )
            .catch(
                action((error) => {
                    // Silence.
                })
            );

        this.activeEditField = "";
    };

    @action changeActiveInlineEdit = (id, schemaKey, key, value) => {
        if (schemaKey !== "changed") {
            this.activeEditField = id + key + schemaKey;
            this.updatedValue = value;
        }
    };

    @action handleChange = (value) => {
        this.updatedValue = value;
    };

    renderHeaderCells() {
        const { onSort, sortColumn, sortOrder } = this.props;
        const schemaKeys = Object.keys(this.schema);

        return schemaKeys.map((schemaKey) => {
            const columnSchema = this.schema[schemaKey];
            const label = columnSchema.label ? columnSchema.label : schemaKey;

            return (
                <Table.HeaderCell
                    key={schemaKey}
                    name={schemaKey}
                    onClick={columnSchema.sortable ? onSort : undefined}
                    sortOrder={sortColumn === schemaKey ? sortOrder : undefined}
                    width={this.schema[schemaKey].width}
                >
                    {label}
                </Table.HeaderCell>
            );
        });
    }

    getButtons = (item) => {
        const buttons = [];
        const { itemActionsProvider, onItemClick } = this.props;

        const {
            _permissions: {
                edit: editPermission = true,
                view: viewPermission = true,
            } = {},
        } = item || {};

        if (onItemClick) {
            buttons.push({
                disabled: !viewPermission,
                icon: editPermission ? "su-pen" : "su-eye",
                onClick: onItemClick,
            });
        }

        if (itemActionsProvider) {
            buttons.push(...itemActionsProvider(item));
        }

        return buttons;
    };

    renderRows() {
        const { data, disabledIds, selections } = this.props;

        return data.map((item) => {
            return (
                <Table.Row
                    buttons={this.getButtons(item)}
                    disabled={disabledIds.includes(item.id)}
                    id={item.id}
                    key={item.id}
                    selected={selections.includes(item.id)}
                >
                    {this.renderCells(item)}
                </Table.Row>
            );
        });
    }

    render() {
        const {
            data,
            limit,
            loading,
            onAllSelectionChange,
            onItemSelectionChange,
            onLimitChange,
            onPageChange,
            paginated,
            adapterOptions: { show_header = true } = {},
            page,
            pageCount,
        } = this.props;

        const table = (
            <Table
                buttons={this.getButtons()}
                onAllSelectionChange={onAllSelectionChange}
                onRowSelectionChange={onItemSelectionChange}
                selectMode={onItemSelectionChange ? "multiple" : undefined}
            >
                {!show_header ? null : (
                    <Table.Header>{this.renderHeaderCells()}</Table.Header>
                )}
                <Table.Body>{this.renderRows()}</Table.Body>
            </Table>
        );

        if (!paginated || (page === 1 && data.length === 0)) {
            return table;
        }

        if (pageCount === undefined) {
            return table;
        }

        const { selected, total } = this.state;

        return (
            <>
                <Pagination
                    currentLimit={limit}
                    currentPage={page}
                    loading={loading}
                    onLimitChange={onLimitChange}
                    onPageChange={onPageChange}
                    totalPages={pageCount}
                >
                    {table}
                </Pagination>
            </>
        );
    }
}

export default InlineTableAdapter;
